import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './assets/wordbook-text.png'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "bottom-navigation" }
const _hoisted_4 = { class: "language-onboarding__flags" }
const _hoisted_5 = ["src", "alt", "onClick", "onKeydown"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_ctx.LocalDatabase.db)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.sidebar.show)
          ? (_openBlock(), _createBlock(_component_Sidebar, {
              key: 0,
              onCloseSidebar: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sidebar.show = !_ctx.sidebar.show))
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_FontAwesomeIcon, {
            class: "hamburger",
            icon: _ctx.faBars,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sidebar.show = !_ctx.sidebar.show))
          }, null, 8, ["icon"]),
          _cache[2] || (_cache[2] = _createElementVNode("img", {
            class: "logo",
            src: _imports_0,
            alt: "logo"
          }, null, -1))
        ]),
        _createVNode(_component_router_view, { class: "view-display" }),
        _createElementVNode("nav", _hoisted_3, [
          _createVNode(_component_router_link, {
            class: "nav-item",
            to: "/"
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode("Words")
            ])),
            _: 1
          }),
          _createVNode(_component_router_link, {
            class: "nav-item",
            to: "/games/anki"
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode("Anki")
            ])),
            _: 1
          })
        ]),
        (_ctx.showLanguageOnboarding)
          ? (_openBlock(), _createBlock(_component_Modal, { key: 1 }, {
              header: _withCtx(() => _cache[5] || (_cache[5] = [
                _createElementVNode("h2", null, "Which language are you learning?", -1)
              ])),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.translationLanguages, (code) => {
                    return (_openBlock(), _createElementBlock("img", {
                      key: code,
                      src: _ctx.imageURL(_ctx.flags[code]),
                      alt: _ctx.languages[code],
                      class: "language-onboarding__flag",
                      onClick: ($event: any) => (_ctx.selectTranslationLanguage(code)),
                      onKeydown: ($event: any) => (_ctx.selectTranslationLanguage(code))
                    }, null, 40, _hoisted_5))
                  }), 128))
                ])
              ]),
              footer: _withCtx(() => _cache[6] || (_cache[6] = [
                _createElementVNode("span", null, null, -1)
              ])),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createBlock(_component_Spinner, { key: 1 }))
}